export default __webpack_public_path__ + "static/media/Comp 2_00031.e5da5a9b.png";